export const TimeZones = [
  {
    value: "America/Argentina/Buenos_Aires",
    label: "Argentina (Buenos Aires)",
  },
  { value: "America/La_Paz", label: "Bolivia" },
  { value: "America/Sao_Paulo", label: "Brazil (São Paulo)" },
  { value: "America/Santiago", label: "Chile" },
  { value: "America/Bogota", label: "Colombia" },
  { value: "America/Costa_Rica", label: "Costa Rica" },
  { value: "America/Havana", label: "Cuba" },
  { value: "America/Santo_Domingo", label: "Dominican Republic" },
  { value: "America/Guayaquil", label: "Ecuador" },
  { value: "America/El_Salvador", label: "El Salvador" },
  { value: "America/Guatemala", label: "Guatemala" },
  { value: "America/Tegucigalpa", label: "Honduras" },
  { value: "America/Mexico_City", label: "Mexico (Mexico City)" },
  { value: "America/Managua", label: "Nicaragua" },
  { value: "America/Panama", label: "Panama" },
  { value: "America/Asuncion", label: "Paraguay" },
  { value: "America/Lima", label: "Peru" },
  { value: "America/Puerto_Rico", label: "Puerto Rico" },
  { value: "America/Montevideo", label: "Uruguay" },
  { value: "America/Caracas", label: "Venezuela" },
  { value: "America/New_York", label: "US Eastern Time" },
  { value: "America/Chicago", label: "US Central Time" },
  { value: "America/Denver", label: "US Mountain Time" },
  { value: "America/Los_Angeles", label: "US Pacific Time" },
  { value: "Europe/London", label: "London" },
  { value: "Europe/Paris", label: "Paris" },
  { value: "Europe/Berlin", label: "Berlin" },
  { value: "Europe/Madrid", label: "Madrid" },
];
